import React from 'react';
import NoResult from '../assets/images/no-result-found.svg';

const PageNotFound = (props) => {
    return (
        <div className="page-not-found-component">
            <div className="no-result-svg-wrap">
                <img src={NoResult} alt="Page not found" />
                <span className="unauthorised-result-text">{props.message || 'You are not authorized to access this feature'}</span>
            </div>
        </div>
    )
}
export default PageNotFound;